import AgreementsComponent from '@/components/Pages/Agreements.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/company/:companyId/agreements/:folderId',
  props: true,
  name: RouteNames.Agreements,
  component: AgreementsComponent,
};

export default route;
